import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

const defaultState = {
  init: false,
  selectedDate: null,
  selectedTime: null,
  selectedShipping: null,
  display: {
    scale: null,
    navbarMenu: false,
    shareDialog: false,
    coverImage: false,
    intro: true,
    takeaway: false,
    storeDelivery: false,
    backdropLoading: false,
  },
}

export const directory = handleActions({
  INIT_DIRECTORY_PAGE: (state, action) => {
    return update(
      state, {
        init: {
          $set: action.payload.init, // bool
        },
      },
    )
  },
  UPDATE_SCALE: (state, action) => {
    return update(
      state, {
        display: {
          scale: {
            $set: action.payload.scale, // string
          },
        },
      },
    )
  },
  UPDATE_DISPLAY_NAVBAR_MENU: (state, action) => {
    return update(
      state, {
        display: {
          navbarMenu: {
            $set: action.payload.display, // bool
          },
        },
      },
    )
  },
  UPDATE_DISPLAY_SHARE_DIALOG: (state, action) => {
    return update(
      state, {
        display: {
          shareDialog: {
            $set: action.payload.display, // bool
          },
        },
      },
    )
  },
  UPDATE_DISPLAY_COVER_IMAGE: (state, action) => {
    return update(
      state, {
        display: {
          coverImage: {
            $set: action.payload.display, // bool
          },
        },
      },
    )
  },
  UPDATE_DISPLAY_INTRO: (state, action) => {
    return update(
      state, {
        display: {
          intro: {
            $set: action.payload.display, // bool
          },
        },
      },
    )
  },
  UPDATE_DISPLAY_BACKDROP_LOADING: (state, action) => {
    return update(
      state, {
        display: {
          backdropLoading: {
            $set: action.payload.display, // bool
          },
        },
      },
    )
  },
  UPDATE_SELECTED_DATE: (state, action) => {
    return update(
      state, {
        selectedDate: {
          $set: action.payload.date,
        },
      },
    )
  },
  UPDATE_SELECTED_TIME: (state, action) => {
    return update(
      state, {
        selectedTime: {
          $set: action.payload.time,
        },
      },
    )
  },
  UPDATE_SELECTED_SHIPPING: (state, action) => {
    return update(
      state, {
        selectedShipping: {
          $set: action.payload.shipping,
        },
      },
    )
  },
  UPDATE_DISPLAY: (state, action) => {
    const { target, display } = action.payload
    return update(
      state, {
        display: {
          [target]: {
            $set: display,
          },
        },
      },
    )
  },
}, defaultState)

export default {
  directory,
}



// WEBPACK FOOTER //
// ./src/reducers/components/directory.js